<div>
  <div [hidden]="!loading">
    <ab-spinner></ab-spinner>
  </div>
  <div *ngIf="!loading">
    <a
      class="dash-list-item dash-list-item--bg-grey"
      uiSref="deploys-show"
      [uiParams]="{ projectId: deploy.projectId, deployId: deploy.id }"
      *ngFor="let deploy of deploys; trackBy: trackById"
    >
      <span class="dash-list-item__number">
        {{ deploy.groupCreatedCount }}
      </span>
      <span class="mx-1">
        <ab-env-label [env]="deploy.environment"></ab-env-label>
      </span>
      <span class="dash-list-item__text">
        <span>{{ deploy.revision | slice: 0:7 }}</span>
        {{ deploy.projectName }}
      </span>
      <span class="mx-1">
        <ab-diff-stat-blocks [deploy]="deploy"></ab-diff-stat-blocks>
      </span>
    </a>
  </div>
</div>
